import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "68",
  height: "56",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "54.077",
  height: "52",
  x: "8",
  y: "1",
  fill: "#077401",
  rx: "26"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M50.618 16.358c1.02.822 1.038 2.172.04 3.014L31.72 35.359c-.485.41-1.151.641-1.846.641s-1.36-.231-1.847-.641l-8.608-7.267c-.997-.842-.979-2.191.041-3.014s2.655-.808 3.652.034l6.762 5.708L46.966 16.39c.997-.841 2.632-.856 3.652-.033",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "54.077",
  height: "52",
  x: "8",
  y: "1",
  stroke: "#077401",
  "stroke-width": "2",
  rx: "26"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }